import { render, staticRenderFns } from "./StepFooter.vue?vue&type=template&id=6675b300"
import script from "./StepFooter.vue?vue&type=script&lang=ts"
export * from "./StepFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports